import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ChargeTemplateInterface } from "../../Entity/Entities/Charge/ChargeTemplateInterface";
import Translator from "../../Translation/Translator";

export default function* chargeTemplateDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_DELETE_REQUEST
    });

    yield call(Http.delete, `charge-templates/${action.payload?.chargeTemplate.id}`);

    const chargeTemplate: ChargeTemplateInterface = action.payload?.chargeTemplate.reinitialize({
      removed: true
    });

    yield put({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_DELETE_SUCCESS,
      payload: {
        chargeTemplate: chargeTemplate
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-charge-template-removed-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, chargeTemplate);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_DELETE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeTemplateDelete() {
  yield takeEvery(Constants.GLOBAL_CHARGE_TEMPLATE_DELETE_START, chargeTemplateDelete);
}
